import type { FaireProductEntity } from "../../entity_types/product";

export const p_rbttydqudv: FaireProductEntity = {
  token: "p_rbttydqudv",
  type: "product",
  name: "Old School Razorbacks Earrings",
  brandToken: "b_hfw2t2ygt4",
  brandName: "Southern Designs by Kristy",
  imageUrl:
    "https://cdn.faire.com/fastly/cbb5ddcd9ec1fd599b7ecd2fa6b5d262d16123411ba9c26469788b26b64b12f4.jpeg",
  galleryImageUrls: [],
  priceDollars: 13.86,
  description:
    "Bring back the nostalgia of Razorback Saturdays with these retro-inspired earrings! Featuring the classic “A” with the fierce Razorback logo, this design takes you straight back to the early 90s. For me, it brings back memories of cheering on the Hogs with my Mamaw Taylor, yelling “Woo Pig Sooie!” at the TV in the living room.\n\nPerfect for game days, tailgates, or showing your Arkansas pride any day of the week. The bold red hog paired with glittery black studs makes these a statement piece that will turn heads and spark conversations with fellow fans who remember the old-school days.\n\n✨ Lightweight for all-day wear\n\n✨ Hypoallergenic posts – perfect for sensitive ears\n\n✨ Handmade with love by Southern Designs by Kristy\n\n📣 A must-have for any true Razorback fan who loves a mix of vintage vibes and modern flair!\n",
  tags: [],
  msrpDollars: 27.71,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:18.829Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
